export const videoButtonSpacings = {
    small: { height: 56, icon: 20 },
    standard: { height: 72, icon: 26 },
    big: { height: 96, icon: 32 },
    huge: { height: 128, icon: 40 },
};
